<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uIibVf/tc-custom/9781398490765.jpg?1680421234246" alt="This image is the cover for the book The Sham"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Sham
      </h1>
      <p class="bookDescription body article font2">
        <p>Our story begins with a pair of hikers: Beebee and Booboo, who were angling along the crooked path of the multicoloured mountainside of Sham Rock. Anyone and everyone knew that they had travelled too far. You and I know it because we are smarter than that. However, Beebee and Booboo did not know it; they had walked too far! What will they discover in this unknown land?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lainy Spinks
      </h2>
      
      <p class="authorDescription body article">A single parent of two boys, Mason and Zak, Lainy has been teaching for 23 years. She has a passion for teaching students of all ages to develop a love of reading.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2e35a3aa